import { useCallback } from 'react';
import useTranslations from '@/core/hooks/use-translations';
import Button from '@/ui/components/Button/Button';

type BuyNowButtonProps = {
  hasStock: boolean;
  isLoading: boolean;
  onBuyNowClick?: () => void;
  onNotifyMeClick?: () => void;
  trackingName: string;
  className?: string;
  iconClassName?: string;
};

const BuyNowButton = ({
  hasStock,
  isLoading,
  onBuyNowClick,
  onNotifyMeClick,
  trackingName,
  className,
  iconClassName,
}: BuyNowButtonProps) => {
  const t = useTranslations();

  const handleClick = useCallback(() => {
    if (hasStock) {
      onBuyNowClick?.();
    } else {
      onNotifyMeClick?.();
    }
  }, [hasStock, onBuyNowClick, onNotifyMeClick]);

  return (
    <Button
      variant="primary"
      icon={hasStock ? 'icon-bag' : 'icon-bell'}
      className={className}
      iconClassName={iconClassName}
      trackingName={trackingName}
      trackingText={hasStock ? 'Buy now' : 'Notify me'}
      onClick={handleClick}
      isLoading={isLoading}
    >
      {hasStock
        ? t('web_pdp_productHeader_buyNow')
        : t('web_pdp_productHeader_notifyMe')}
    </Button>
  );
};

export default BuyNowButton;
